const appInfo = {
  stage: "test",
  test: {
    shortName: "OnTrack",
    longName: "OnTrack"
  }
};

export { appInfo };
